module.exports = __webpack_public_path__ + "img/right-image.5b8b3dad.png";